import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  initial: 'M',
  color: 'bg-pink-100 text-pink-700',
  name: 'Mariana G.',
  location: 'Mamá de Sofía, 5 años',
  plan: 'Plan Premium',
  text: 'Mi hija reconocía todas las letras. Todas. Pero cuando intentaba leer una palabra completa se quedaba congelada. Pensé que algo estaba mal. Hoy ya puede leer pequeñas frases sola y lo mejor es que volvió a confiar en ella misma.'
}, {
  initial: 'L',
  color: 'bg-blue-100 text-blue-700',
  name: 'Laura S.',
  location: 'Mamá de Tomás, 6 años',
  plan: 'Plan Base',
  text: 'Cada tarde terminaba igual: frustración, cansancio y lágrimas. Yo no sabía cómo enseñarle. Este sistema me mostró exactamente qué hacer y en qué orden.'
}, {
  initial: 'F',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Fernando R.',
  location: 'Papá de Mateo, 6 años',
  plan: 'Plan Base',
  text: 'Lo que más me gustó fue que no tuve que improvisar. Todo estaba organizado paso a paso. Mi hijo pasó de leer sílabas aisladas a leer palabras completas.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-283">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-284">
        <div className="text-center mb-8 flex flex-col items-center" data-id="element-285">
          <Heart className="w-8 h-8 text-red-500 mb-4 fill-current" data-id="element-286" />
          <h2 className="text-3xl font-bold text-navy" data-id="element-287">
            MÁS PADRES QUE YA LO TIENEN
          </h2>
        </div>

        <div className="space-y-6" data-id="element-288">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg shadow-slate-200/50 border border-slate-100" data-id="element-289">
              <div className="flex text-gold mb-4" data-id="element-290">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-291" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic" data-id="element-292">
                "{t.text}"
              </p>

              <div className="flex items-center justify-between border-t border-slate-100 pt-4" data-id="element-293">
                <div className="flex items-center" data-id="element-294">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${t.color} mr-3`} data-id="element-295">
                    {t.initial}
                  </div>
                  <div data-id="element-296">
                    <div className="font-bold text-navy text-sm" data-id="element-297">{t.name}</div>
                    <div className="text-xs text-slate-500" data-id="element-298">
                      📍 {t.location}
                    </div>
                  </div>
                </div>
                <div className="bg-slate-100 text-slate-600 text-xs font-bold px-3 py-1 rounded-full" data-id="element-299">
                  {t.plan}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}